import * as React from 'react';
import { Tab, TabPanel } from '@components/moleculs/tabs';
import type { SteppedTabsComposition } from '@components/organisms/stepped-tabs/types';
import type { TabProps } from '@mui/material/Tab';
import type { TabsProps } from '@mui/material/Tabs';
import cn from 'classnames';

import { SteppedTabsContainer } from './styles';

export const SteppedTab: React.FC<TabProps & { isSuccess?: boolean; isCurrent?: boolean }> = ({
    isSuccess,
    isCurrent,
    className,
    ...rest
}) => (
    <Tab
        className={cn(
            `tab__item`,
            {
                'success-tab': isSuccess,
                'current-tab': isCurrent,
            },
            className,
        )}
        {...rest}
    />
);

export const SteppedTabs: React.FC<TabsProps> & SteppedTabsComposition = (props) => (
    <SteppedTabsContainer {...props} />
);

SteppedTabs.TabPanel = TabPanel;
SteppedTabs.Tab = SteppedTab;
